import { TransactionJournalCode } from '@features/transactions/enums/transactionJournalCode'

export interface TransactionsFilterJournalCode {
  label: string
  value: string
}

/* Standard French journal codes/names - should not be translated, they're fixed accounting terms */
export const getTransactionsFilterJournalCodes = (): TransactionsFilterJournalCode[] => [
  { label: `Ventes (${TransactionJournalCode.Ventes})`, value: TransactionJournalCode.Ventes },
  { label: `Achats (${TransactionJournalCode.Achats})`, value: TransactionJournalCode.Achats },
  { label: `Banque (${TransactionJournalCode.Banque})`, value: TransactionJournalCode.Banque },
  { label: `Caisse (${TransactionJournalCode.Caisse})`, value: TransactionJournalCode.Caisse },
  {
    label: `Opérations diverses (${TransactionJournalCode.OperationsDiverses})`,
    value: TransactionJournalCode.OperationsDiverses,
  },
  { label: `À-nouveaux (${TransactionJournalCode.ANouveaux})`, value: TransactionJournalCode.ANouveaux },
]
